export default function(newElement, beforeElement) {
  beforeElement.parentNode.insertBefore(newElement, beforeElement);
}
